module.exports = __webpack_public_path__ + "./images/2e9ddc94b3247688a443299cb97574fb.webp";